module.exports = __webpack_public_path__ + "static/img/guard_empty.f8a5d49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guard/guard_empty.png
// module id = EVZr
// module chunks = 0